module.exports = __webpack_public_path__ + "898f017a07baf8895c14d327df2fea34.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drum_spelen.mp3
// module id = 49
// module chunks = 0